import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CartService } from 'src/app/services/cart.service';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
    imports: [RouterModule, FontAwesomeModule, AsyncPipe],
    selector: 'app-cart-info',
    templateUrl: './cart-info.component.html',
    styleUrls: ['./cart-info.component.css']
})
export class CartInfoComponent implements OnInit {

  private readonly cartService = inject(CartService);

  public faShoppingCart = faShoppingCart;
  /** Read in the template with `async`, so it ends with the component (#199). */
  public readonly completeItemCount$: Observable<number> = this.cartService.$cart.pipe(
    map((cart) => (cart?.cartPositions?.length ? cart.cartPositions.map((cp) => cp.count).reduce((a, b) => a + b) : 0))
  );

  ngOnInit(): void {
    if (!this.cartService.cart) {
      this.cartService.reloadCart();
    }
  }

}
